module.exports = __webpack_public_path__ + "img/ahorro.388d2225.svg";